<template><CBox>Hi</CBox></template>

<script>
export default {
  name: "AdminClientCreate",
};
</script>

<style scoped></style>
